import {
  ArrowRight,
  ArrowRightAlt,
  CalendarMonth,
  CheckCircle,
  Check,
  CheckCircleOutline,
  DoneAll,
  Download,
  FileOpenOutlined,
  FolderCopyRounded,
  FolderRounded,
  FormatListBulleted,
  Home,
  InfoOutlined,
  LanOutlined,
  LockClockOutlined,
  MoreHoriz,
  Person,
  Person2,
  Person2Rounded,
  Schedule,
  Window,
  Inbox,
  InboxOutlined,
  InboxRounded,
  InboxSharp,
} from "@mui/icons-material";
import { Pagination } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  CircularProgressbar,
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { FaClock, FaEye } from "react-icons/fa";

import "../assets_/timeline.css";
import { Link, useParams } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";
import DetailsDecLoader1 from "./Loader/DetailsDecLoader1";
import TimelineLoader from "./Loader/TimelineLoader";
import ProgressLoader from "./Loader/ProgressLoader";
import Timeline from "./Timeline";
import RoadMapLoader from "./Loader/RoadMapLoader";
import {
  calculateDuration,
  formatTime,
  renderStatus,
} from "./SharedData/utils";
import TableLoader from "./Loader/TableLoader";
import ErrorPage from "./Error/ErrorPage";
import AllDocument from "./DeatilsDeclaration/AllDocuments";
import { ApiUrl } from "../config";

const DetailsDeclarations = () => {
  //const percentage = 60;
  const [activeTab, setActiveTab] = useState("tab1");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const [DocumentactiveTab, setDocumentActiveTab] = useState("tab1");

  const handleDocumentTabClick = (tab) => {
    setDocumentActiveTab(tab);
  };

  const [PageactiveTab, setPageActiveTab] = useState("grid");

  const handlePageTabClick = (tab) => {
    setPageActiveTab(tab);
  };

  const [declaration, setDeclarationDetails] = useState(null);
  const [roadmapSteps, setRoadmapSteps] = useState([]);
  const [roadmap, setRoadmap] = useState([]);
  const [loading, setLoading] = useState(true);
  const [prochainRdv, setprochainRdv] = useState([]);
  const [loadingRdv, setLoadingRdv] = useState(true);
  const [currentPageRdv, setCurrentPageRdv] = useState(1);
  const [totalPagesRdv, setTotalPagesRdv] = useState(1);
  const [searchDocumentQuery, setSearchDocumentQuery] = useState("");

  const { dec_uid } = useParams();
  const token = Cookies.get("access_token");

  const GetDeclarationsByDec_uid = async () => {
    if (token && dec_uid) {
      try {
        setLoading(true);
        const response = await fetch(
          `${ApiUrl}get-declarations-details-by-dec-uid?dec_uid=${dec_uid}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();
        console.log(data);
        setDeclarationDetails(data.declaration);
        setRoadmapSteps(data.roadmapSteps);
        setRoadmap(data.roadmap);
        setLoading(false);
        console.log(data);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    }
  };

  const GetProchainRdv = async (page = 1) => {
    if (token && dec_uid) {
      try {
        setLoadingRdv(true);
        const response = await fetch(
          `${ApiUrl}prochain-rdv-patient?dec_uid=${dec_uid}&page=${page}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();

        console.log(data);
        setprochainRdv(data.data);
        setCurrentPageRdv(data.current_page);
        setTotalPagesRdv(data.last_page);

        setLoadingRdv(false);
        console.log(data);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoadingRdv(false);
      }
    }
  };

  useEffect(() => {
    GetDeclarationsByDec_uid();
  }, [dec_uid]);

  useEffect(() => {
    GetProchainRdv(currentPageRdv);
  }, [dec_uid, currentPageRdv]);

  const handlePageChangeRdv = (event, page) => {
    setCurrentPageRdv(page);
  };

  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchDocumentQuery(e.target.value);
  };
  return (
    <div>
      {declaration ? (
        <>
          <div className="row">
            <div className=" d-flex justify-content-between align-items-center mb-2">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb breadcrumb-no-gutter">
                  <li className="breadcrumb-item">
                    <Link
                      to={"/mon-espace/"}
                      className="breadcrumb-link"
                      href="javascript:;"
                    >
                      Page d'acceuil
                    </Link>
                  </li>
                  <li className="breadcrumb-item " aria-current="page">
                    <Link
                      to={"/mon-espace/mes-declarations"}
                      className="breadcrumb-link"
                      href="javascript:;"
                    >
                      Mes Dossiers
                    </Link>
                  </li>
                  <li
                    className="breadcrumb-item active"
                    style={{ color: "rgb(255, 77, 7)" }}
                    aria-current="page"
                  >
                    Détails
                  </li>
                </ol>
              </nav>

              <div className="col-auto">
                <ul
                  className="nav nav-segment"
                  id="connectionsTab"
                  role="tablist"
                >
                  <li className="nav-item p-1" role="presentation">
                    <button
                      className={`nav-link p-2 fw-bold ${
                        PageactiveTab === "grid" ? "active" : ""
                      }`}
                      id="grid-tab"
                      onClick={() => handlePageTabClick("grid")}
                      role="tab"
                      aria-controls="grid"
                      aria-selected={PageactiveTab === "grid"}
                      title="Column view"
                    >
                      <InfoOutlined
                        className="mb-1"
                        style={{ fontSize: "18px" }}
                      />{" "}
                      Informations
                    </button>
                  </li>
                  <li className="nav-item p-1" role="presentation">
                    <button
                      className={`nav-link p-2 fw-bold ${
                        PageactiveTab === "roadmap" ? "active" : ""
                      }`}
                      id="roadmap-tab"
                      onClick={() => handlePageTabClick("roadmap")}
                      role="tab"
                      aria-controls="roadmap"
                      aria-selected={PageactiveTab === "roadmap"}
                      title="List view"
                    >
                      <LanOutlined
                        className="mb-1"
                        style={{ fontSize: "18px" }}
                      />{" "}
                      Road Map
                    </button>
                  </li>
                  <li className="nav-item p-1" role="presentation">
                    <button
                      className={`nav-link p-2 fw-bold ${
                        PageactiveTab === "documents" ? "active" : ""
                      }`}
                      id="documents-tab"
                      onClick={() => handlePageTabClick("documents")}
                      role="tab"
                      aria-controls="documents"
                      aria-selected={PageactiveTab === "documents"}
                      title="List view"
                    >
                      <FolderRounded
                        className="mb-1"
                        style={{ fontSize: "18px" }}
                      />{" "}
                      Documents
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="tab-content">
            <div className="tab-content">
              {PageactiveTab === "grid" && (
                <div id="grid" role="tabpanel">
                  <div className="row">
                    <div className="col-8 stretch-card">
                      <div className="card">
                        <div className="card-body">
                          <h5
                            className="title mb-4"
                            style={{ color: "#052c65" }}
                          >
                            # Prise en charge N° 1
                          </h5>

                          {loading ? (
                            // Show the DetailsDecLoader1 component while loading
                            <DetailsDecLoader1 />
                          ) : (
                            <>
                              <div className="d-flex mb-1">
                                <span className="text-muted fw-bold">
                                  <Home className="mb-2" /> Centre de santé :
                                </span>
                                <span className="ms-2">
                                  {declaration?.centre}
                                </span>
                              </div>
                              <div className="d-flex">
                                <span className="text-muted fw-bold">
                                  <Person2 className="mb-2" /> Assistant
                                  Responsable :
                                </span>
                                <span className="ms-2">
                                  {declaration?.emp_resp}
                                </span>
                                <p className="date">
                                  {new Date(
                                    declaration?.date_declaration
                                  ).toLocaleDateString("en-GB")}
                                </p>
                              </div>
                            </>
                          )}

                          <div className="row mt-3">
                            <div
                              className="timeline-steps aos-init aos-animate"
                              data-aos="fade-up"
                            >
                              {loading ? (
                                // Show loader while data is loading
                                <TimelineLoader />
                              ) : (
                                roadmapSteps.map((step, index) => (
                                  <div className="timeline-step" key={index}>
                                    <div
                                      className="timeline-content"
                                      data-toggle="popover"
                                      data-trigger="hover"
                                      data-placement="top"
                                    >
                                      <div
                                        className={`inner-circle ${
                                          step.total === step.finished
                                            ? "active"
                                            : ""
                                        }`}
                                      >
                                        {step.total === step.finished ? (
                                          <DoneAll />
                                        ) : (
                                          <Schedule />
                                        )}
                                      </div>
                                      <p className="h6 mt-3 mb-1">
                                        {step.rdv_name}
                                      </p>
                                      <span className="badge badge-pill badge-light">
                                        {step.rdv_name !== "Gendarme" &&
                                        step.rdv_name !== "Procureur" ? (
                                          <span>
                                            {step.finished} / {step.total}
                                          </span>
                                        ) : (
                                          <span>-</span>
                                        )}
                                      </span>
                                    </div>
                                  </div>
                                ))
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-4 stretch-card">
                      <div className="card">
                        <div className="card-body">
                          <h5 className="title mb-4"># Progrès</h5>
                          <div className="progress-bar-container d-flex justify-content-center align-items-center">
                            {loading ? (
                              <ProgressLoader /> // Show the loader while loading
                            ) : (
                              <CircularProgressbar
                                value={declaration?.progress}
                                text={`${declaration?.progress}%`}
                                styles={buildStyles({
                                  strokeLinecap: "butt",
                                  textSize: "16px",
                                  pathTransitionDuration: 0.5,
                                  pathColor: `#ff4d07`,
                                  textColor: "#ff4d07",
                                  trailColor: "#ffe7cd",
                                  backgroundColor:
                                    "rgba(248, 249, 252, 0.6549019608)",
                                  strokeWidth: 30,
                                })}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row mt-2">
                    <div className="col">
                      <div className="card">
                        <div className="card-body">
                          <h5 className="title mb-4">
                            # Mes Prochain rendez-vous
                          </h5>
                          {/* {loadingRdv ? <p>Loading...</p> : <p>Data Loaded</p>}
                      <pre>{JSON.stringify(prochainRdv, null, 2)}</pre> */}
                          <div className="row">
                            {loadingRdv ? (
                              <TableLoader rows={5} columns={9} />
                            ) : (
                              <table className="table table-responsive table-hover mt-4">
                                <thead>
                                  <tr>
                                    <th scope="col">#ID</th>
                                    <th scope="col">Intervenant</th>
                                    <th scope="col">Séance</th>
                                    <th scope="col">Status 1</th>
                                    <th scope="col"> Date</th>
                                    <th scope="col"> Heures</th>
                                    <th scope="col">Durée</th>
                                    <th scope="col">Mode</th>

                                    <th scope="col">Status 1</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {prochainRdv.length === 0 ? (
                                    <tr>
                                      <td colspan="100%">
                                        <div className="text-center p-5">
                                          <div className="mt-md-3 mt-xl-0 text-muted">
                                            {/* <i className="feather icon-inbox display-6"></i> */}
                                            <InboxOutlined
                                              style={{
                                                fontSize: "50px",
                                                color: "rgb(167 166 166)",
                                              }}
                                            />
                                          </div>
                                          <p
                                            className="empty-title"
                                            style={{
                                              marginTop: "8px",
                                              fontSize: "16px",
                                              color: "rgb(112 110 110)",
                                            }}
                                          >
                                            Aucun résultat trouvé
                                          </p>
                                        </div>
                                      </td>
                                    </tr>
                                  ) : (
                                    prochainRdv.map((rdv, index) => (
                                      <tr key={rdv.id}>
                                        <td>#{index + 1}</td>
                                        <td>
                                          <div className="d-flex align-items-center">
                                            <div className="ms-3">
                                              <p className="fw-bold mb-1">
                                                {rdv?.employe?.nom}{" "}
                                                {rdv?.employe?.prenom}
                                              </p>
                                            </div>
                                          </div>
                                        </td>
                                        <td>
                                          <p className="fw-normal mb-1">
                                            {rdv?.rdv_name}
                                          </p>
                                        </td>
                                        <td>
                                          <span className="legend-indicator custom-bg-success "></span>{" "}
                                          <span style={{ color: "#677788" }}>
                                            Confirmé
                                          </span>
                                        </td>
                                        <td>{rdv.date}</td>
                                        <td>
                                          {formatTime(rdv.startTime)} -{" "}
                                          {formatTime(rdv.endTime)}
                                        </td>
                                        <td>
                                          <p>
                                            {calculateDuration(
                                              rdv?.startTime,
                                              rdv?.endTime
                                            )}
                                          </p>
                                        </td>
                                        <td>
                                          <span
                                            className={`badge bg-${
                                              rdv.type_rdv === "Physique"
                                                ? "primary"
                                                : "secondary"
                                            }`}
                                          >
                                            {rdv?.type_rdv}
                                          </span>
                                        </td>
                                        <td>
                                          <span
                                            className={`badge ${
                                              renderStatus(rdv?.status)
                                                .className
                                            }`}
                                          >
                                            {renderStatus(rdv?.status).text}
                                          </span>
                                        </td>
                                      </tr>
                                    ))
                                  )}
                                </tbody>
                                <tfoot>
                                  {prochainRdv && prochainRdv.length > 0 ? (
                                    <tr>
                                      <td colSpan="9">
                                        <div className="d-flex justify-content-between align-items-center p-1">
                                          <div>
                                            Showing {prochainRdv.length} of{" "}
                                            {totalPagesRdv}
                                            entries
                                          </div>
                                          <div>
                                            <Pagination
                                              count={totalPagesRdv}
                                              page={currentPageRdv}
                                              onChange={handlePageChangeRdv}
                                              color="primary"
                                              shape="rounded"
                                              sx={{
                                                "& .MuiPaginationItem-root": {
                                                  borderRadius: "50px", // Rounded style for pagination items
                                                  backgroundColor: "#f1f1f1", // Light gray background for unselected pages
                                                  "&.Mui-selected": {
                                                    backgroundColor:
                                                      "rgb(255, 77, 7)", // Bootstrap blue color when selected
                                                    color: "white", // White text when selected
                                                  },
                                                  "&:hover": {
                                                    backgroundColor: "#e0e0e0", // Hover color for pagination items
                                                  },
                                                },
                                                marginTop: "20px",
                                              }}
                                            />
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  ) : (
                                    <tr>
                                      <td colSpan="9"></td>
                                    </tr>
                                  )}
                                </tfoot>
                              </table>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              )}
              {PageactiveTab === "roadmap" && (
                <div id="roadmap" role="tabpanel">
                  <div className="row">
                    <div className="card">
                      <div className="card-header">
                        <h5 className="title mb-4" style={{ color: "#052c65" }}>
                          # Feuille de route (RoadMap)
                        </h5>
                      </div>
                      <div className="card-body">
                        <section className="timeline_area section_padding_130">
                          <div className="container">
                            <div className="row">
                              <div className="col-12">
                                <div className="apland-timeline-area">
                                  {loading ? (
                                    <RoadMapLoader />
                                  ) : (
                                    <Timeline roadmap={roadmap} />
                                  )}
                                  {/* ------------------------------------
                              <div className="single-timeline-area">
                                <div
                                  className="timeline-date assis wow fadeInLeft"
                                  data-wow-delay="0.1s"
                                  style={{
                                    visibility: "visible",
                                    animationDelay: "0.1s",
                                    animationName: "fadeInLeft",
                                  }}
                                >
                                  <p>Assistant sociale</p>
                                </div>
                                <div className="row">
                                  <div className="col-12 col-md-6 col-lg-4">
                                    <div
                                      className="single-timeline-content assis d-flex wow fadeInLeft"
                                      data-wow-delay="0.3s"
                                      style={{
                                        visibility: "visible",
                                        animationDelay: "0.3s",
                                        animationName: "fadeInLeft",
                                      }}
                                    >
                                      <div className="timeline-icon assis">
                                        {" "}
                                        <Check
                                          style={{ fontSize: "20px" }}
                                          className="text-white"
                                        />{" "}
                                      </div>
                                      <div className="timeline-text">
                                        <div className="d-flex justify-content-between">
                                          <h6 className="me-5">02-05-2025</h6>
                                          <p className="fw-bold">
                                            10:30 - 11:00
                                          </p>
                                        </div>
                                        <p
                                          className="fw-bold title"
                                          style={{ color: "rgb(5, 44, 101)" }}
                                        >
                                          {" "}
                                          Assia Salam
                                        </p>
                                        <span className="badge badge-success">
                                          <CheckCircleOutline
                                            style={{ fontSize: "15px" }}
                                            className="mb-1"
                                          />{" "}
                                          Términé
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-12 col-md-6 col-lg-4">
                                    <div
                                      className="single-timeline-content assis d-flex wow fadeInLeft"
                                      data-wow-delay="0.3s"
                                      style={{
                                        visibility: "visible",
                                        animationDelay: "0.3s",
                                        animationName: "fadeInLeft",
                                      }}
                                    >
                                      <div className="timeline-icon assis">
                                        {" "}
                                        <Check
                                          style={{ fontSize: "20px" }}
                                          className="text-white"
                                        />{" "}
                                      </div>
                                      <div className="timeline-text">
                                        <div className="d-flex justify-content-between">
                                          <h6 className="me-5">02-05-2025</h6>
                                          <p className="fw-bold">
                                            10:30 - 11:00
                                          </p>
                                        </div>
                                        <p
                                          className="fw-bold title"
                                          style={{ color: "rgb(5, 44, 101)" }}
                                        >
                                          {" "}
                                          Assia Salam
                                        </p>
                                        <span className="badge badge-success">
                                          <CheckCircleOutline
                                            style={{ fontSize: "15px" }}
                                            className="mb-1"
                                          />{" "}
                                          Términé
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="single-timeline-area">
                                <div
                                  className="timeline-date medecin wow fadeInLeft"
                                  data-wow-delay="0.1s"
                                  style={{
                                    visibility: "visible",
                                    animationDelay: "0.1s",
                                    animationName: "fadeInLeft",
                                  }}
                                >
                                  <p>Medecin</p>
                                </div>
                                <div className="row">
                                  <div className="col-12 col-md-6 col-lg-4">
                                    <div
                                      className="single-timeline-content medecin d-flex wow fadeInLeft"
                                      data-wow-delay="0.3s"
                                      style={{
                                        visibility: "visible",
                                        animationDelay: "0.3s",
                                        animationName: "fadeInLeft",
                                      }}
                                    >
                                      <div className="timeline-icon medecin">
                                        {" "}
                                        <Check
                                          style={{ fontSize: "20px" }}
                                          className="text-white"
                                        />{" "}
                                      </div>
                                      <div className="timeline-text">
                                        <div className="d-flex justify-content-between">
                                          <h6 className="me-5">02-05-2025</h6>
                                          <p className="fw-bold">
                                            10:30 - 11:00
                                          </p>
                                        </div>
                                        <p
                                          className="fw-bold title"
                                          style={{ color: "rgb(5, 44, 101)" }}
                                        >
                                          Dr.Yassine John
                                        </p>
                                        <span className="badge badge-success">
                                          <CheckCircleOutline
                                            style={{ fontSize: "15px" }}
                                            className="mb-1"
                                          />{" "}
                                          Términé
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-12 col-md-6 col-lg-4">
                                    <div
                                      className="single-timeline-content medecin d-flex wow fadeInLeft"
                                      data-wow-delay="0.3s"
                                      style={{
                                        visibility: "visible",
                                        animationDelay: "0.3s",
                                        animationName: "fadeInLeft",
                                      }}
                                    >
                                      <div className="timeline-icon medecin">
                                        {" "}
                                        <Check
                                          style={{ fontSize: "20px" }}
                                          className="text-white"
                                        />{" "}
                                      </div>
                                      <div className="timeline-text">
                                        <div className="d-flex justify-content-between">
                                          <h6 className="me-5">02-05-2025</h6>
                                          <p className="fw-bold">
                                            10:30 - 11:00
                                          </p>
                                        </div>
                                        <p
                                          className="fw-bold title"
                                          style={{ color: "rgb(5, 44, 101)" }}
                                        >
                                          Dr.Yassine John
                                        </p>
                                        <span className="badge badge-warning">
                                          <FaClock /> En attente
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="single-timeline-area">
                                <div
                                  className="timeline-date psychologue wow fadeInLeft"
                                  data-wow-delay="0.1s"
                                  style={{
                                    visibility: "visible",
                                    animationDelay: "0.1s",
                                    animationName: "fadeInLeft",
                                  }}
                                >
                                  <p>Psychologue</p>
                                </div>
                                <div className="row">
                                  <div className="col-12 col-md-6 col-lg-4">
                                    <div
                                      className="single-timeline-content psychologue d-flex wow fadeInLeft"
                                      data-wow-delay="0.3s"
                                      style={{
                                        visibility: "visible",
                                        animationDelay: "0.3s",
                                        animationName: "fadeInLeft",
                                      }}
                                    >
                                      <div className="timeline-icon psychologue">
                                        {" "}
                                        <Check
                                          style={{ fontSize: "20px" }}
                                          className="text-white"
                                        />{" "}
                                      </div>
                                      <div className="timeline-text">
                                        <div className="d-flex justify-content-between">
                                          <h6 className="me-5">02-05-2025</h6>
                                          <p className="fw-bold">
                                            10:30 - 11:00
                                          </p>
                                        </div>
                                        <p
                                          className="fw-bold title"
                                          style={{ color: "rgb(5, 44, 101)" }}
                                        >
                                          Dr.Amine Berrada
                                        </p>
                                        <span className="badge badge-warning">
                                          <FaClock /> En attente
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-12 col-md-6 col-lg-4">
                                    <div
                                      className="single-timeline-content psychologue d-flex wow fadeInLeft"
                                      data-wow-delay="0.3s"
                                      style={{
                                        visibility: "visible",
                                        animationDelay: "0.3s",
                                        animationName: "fadeInLeft",
                                      }}
                                    >
                                      <div className="timeline-icon psychologue">
                                        {" "}
                                        <Check
                                          style={{ fontSize: "20px" }}
                                          className="text-white"
                                        />{" "}
                                      </div>
                                      <div className="timeline-text">
                                        <div className="d-flex justify-content-between">
                                          <h6 className="me-5">02-05-2025</h6>
                                          <p className="fw-bold">
                                            10:30 - 11:00
                                          </p>
                                        </div>
                                        <p
                                          className="fw-bold title"
                                          style={{ color: "rgb(5, 44, 101)" }}
                                        >
                                          Dr.Amine Berrada
                                        </p>
                                        <span className="badge badge-warning">
                                          <FaClock /> En attente
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-12 col-md-6 col-lg-4">
                                    <div
                                      className="single-timeline-content psychologue d-flex wow fadeInLeft"
                                      data-wow-delay="0.3s"
                                      style={{
                                        visibility: "visible",
                                        animationDelay: "0.3s",
                                        animationName: "fadeInLeft",
                                      }}
                                    >
                                      <div className="timeline-icon psychologue">
                                        {" "}
                                        <Check
                                          style={{ fontSize: "20px" }}
                                          className="text-white"
                                        />{" "}
                                      </div>
                                      <div className="timeline-text">
                                        <div className="d-flex justify-content-between">
                                          <h6 className="me-5">03-06-2025</h6>
                                          <p className="fw-bold">
                                            10:30 - 11:00
                                          </p>
                                        </div>
                                        <p
                                          className="fw-bold title"
                                          style={{ color: "rgb(5, 44, 101)" }}
                                        >
                                          Dr.Amine Berrada
                                        </p>
                                        <span className="badge badge-warning">
                                          <FaClock /> En attente
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </section>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {PageactiveTab === "documents" && (
                <div id="documents" role="tabpanel">
                  <div className="row mt-2">
                    <div className="col-3 d-flex flex-column">
                      <div className="card flex-grow-1 h-100">
                        <div className="card-body">
                          <div
                            className="nav flex-column nav-pills"
                            id="v-pills-tab"
                            role="tablist"
                            aria-orientation="vertical"
                          >
                            <a
                              className={`nav-link ${
                                DocumentactiveTab === "tab1" ? "active" : ""
                              }`}
                              id="v-pills-tab1-tab"
                              data-toggle="pill"
                              role="tab"
                              aria-controls="v-pills-tab1"
                              aria-selected={DocumentactiveTab === "tab1"}
                              onClick={() => handleDocumentTabClick("tab1")}
                            >
                              Attestaion PEC <ArrowRight />
                            </a>
                            <a
                              className={`nav-link ${
                                DocumentactiveTab === "tab2" ? "active" : ""
                              }`}
                              id="v-pills-tab2-tab"
                              data-toggle="pill"
                              role="tab"
                              aria-controls="v-pills-tab2"
                              aria-selected={DocumentactiveTab === "tab2"}
                              onClick={() => handleDocumentTabClick("tab2")}
                            >
                              Pièces d'identité <ArrowRight />
                            </a>
                            <a
                              className={`nav-link ${
                                DocumentactiveTab === "tab3" ? "active" : ""
                              }`}
                              id="v-pills-tab3-tab"
                              data-toggle="pill"
                              role="tab"
                              aria-controls="v-pills-tab3"
                              aria-selected={DocumentactiveTab === "tab3"}
                              onClick={() => handleDocumentTabClick("tab3")}
                            >
                              Autre Attestaions <ArrowRight />
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-9 d-flex flex-column">
                      <div className="card flex-grow-1 h-100">
                        <div className="card-body">
                          <div className="d-flex align-items-center justify-content-between mb-2">
                            <h5 className="title" style={{ color: "#052c65" }}>
                              # Documents lié à cette pec
                            </h5>
                            <div className="single-input-inner style-border">
                              <input
                                type="text"
                                value={searchDocumentQuery}
                                onChange={handleSearchChange}
                                className="form-control mb-3"
                                style={{
                                  height: "42px",
                                  borderRadius: "5px",
                                  border: "1px solid #ccc",
                                  padding: "10px",
                                }}
                                placeholder="Rechercher..."
                              />
                            </div>
                          </div>
                          <div className="tab-content" id="v-pills-tabContent">
                            <div
                              className={`tab-pane fade ${
                                DocumentactiveTab === "tab1"
                                  ? "show active"
                                  : ""
                              }`}
                              id="v-pills-tab1"
                              role="tabpanel"
                            >
                              <div className="table-responsive border border-bottom">
                                <AllDocument dec_uid={dec_uid} token={token} searchDocumentQuery={searchDocumentQuery}/>
                              </div>
                            </div>
                            <div
                              className={`tab-pane fade ${
                                DocumentactiveTab === "tab2"
                                  ? "show active"
                                  : ""
                              }`}
                              id="v-pills-tab2"
                              role="tabpanel"
                            >
                              <ul className="list-group">
                                {/* <!-- List Item --> */}
                                <li className="list-group-item">
                                  <div className="row align-items-center">
                                    <div className="col-auto">
                                      <img
                                        className="avatar avatar-xs avatar-4x3"
                                        src="https://htmlstream.com/preview/front-dashboard-v2.1.1/assets/svg/brands/google-docs-icon.svg"
                                        alt="Image Description"
                                      />
                                    </div>
                                    {/* <!-- End Col --> */}

                                    <div className="col">
                                      <h5 className="mb-0">
                                        <a className="text-dark" href="#">
                                          Liveret de famille
                                        </a>
                                      </h5>
                                      <ul className="list-inline list-separator small text-body">
                                        <li className="list-inline-item">
                                          Dr.Yassine Jaaidi
                                        </li>
                                        <li className="list-inline-item">
                                          25-12-2024
                                        </li>
                                      </ul>
                                    </div>
                                    {/* <!-- End Col --> */}

                                    <div className="col-auto">
                                      {/* <!-- Dropdown --> */}
                                      <div className="dropdown">
                                        <button
                                          type="button"
                                          className="p-3 card-dropdown-btn rounded-circle"
                                          style={{
                                            background: "none",
                                            border: "none",
                                          }}
                                          id="filesGridDropdown1"
                                          data-bs-toggle="dropdown"
                                          aria-expanded="false"
                                        >
                                          <MoreHoriz />
                                        </button>

                                        <div
                                          className="dropdown-menu dropdown-menu-end"
                                          aria-labelledby="filesListDropdown1"
                                          style={{ minWidth: " 13rem" }}
                                        >
                                          <a className="dropdown-item" href="#">
                                            <i className="bi-share dropdown-item-icon"></i>{" "}
                                            <FileOpenOutlined className="dropdown-item-icon" />
                                            Ouvrir
                                          </a>
                                          <a className="dropdown-item" href="#">
                                            <i className="bi-folder-plus dropdown-item-icon"></i>{" "}
                                            <Download className="dropdown-item-icon" />{" "}
                                            Télécharger
                                          </a>
                                        </div>
                                      </div>
                                      {/* <!-- End Dropdown --> */}
                                    </div>
                                    {/* <!-- End Col --> */}
                                  </div>
                                  {/* <!-- End Row --> */}
                                </li>
                                {/* <!-- End List Item --> */}

                                {/* <!-- List Item --> */}
                                <li className="list-group-item">
                                  <div className="row align-items-center">
                                    <div className="col-auto">
                                      <img
                                        className="avatar avatar-xs avatar-4x3"
                                        src="https://htmlstream.com/preview/front-dashboard-v2.1.1/assets/svg/brands/pdf-icon.svg"
                                        alt="Image Description"
                                      />
                                    </div>
                                    {/* <!-- End Col --> */}

                                    <div className="col">
                                      <h5 className="mb-0">
                                        <a className="text-dark" href="#">
                                          Certificat médical
                                        </a>
                                      </h5>
                                      <ul className="list-inline list-separator small text-body">
                                        <li className="list-inline-item">
                                          Dr.Yassine Jaaidi
                                        </li>
                                        <li className="list-inline-item">
                                          06-03-2022
                                        </li>
                                      </ul>
                                    </div>
                                    {/* <!-- End Col --> */}

                                    <div className="col-auto">
                                      {/* <!-- Dropdown --> */}
                                      <div className="dropdown">
                                        <button
                                          type="button"
                                          className="p-3 card-dropdown-btn rounded-circle"
                                          style={{
                                            background: "none",
                                            border: "none",
                                          }}
                                          id="filesGridDropdown1"
                                          data-bs-toggle="dropdown"
                                          aria-expanded="false"
                                        >
                                          <MoreHoriz />
                                        </button>

                                        <div
                                          className="dropdown-menu dropdown-menu-end"
                                          aria-labelledby="filesListDropdown2"
                                          style={{ minWidth: "13rem" }}
                                        >
                                          <a className="dropdown-item" href="#">
                                            <i className="bi-share dropdown-item-icon"></i>{" "}
                                            <FileOpenOutlined className="dropdown-item-icon" />
                                            Ouvrir
                                          </a>
                                          <a className="dropdown-item" href="#">
                                            <i className="bi-folder-plus dropdown-item-icon"></i>{" "}
                                            <Download className="dropdown-item-icon" />{" "}
                                            Télécharger
                                          </a>
                                        </div>
                                      </div>
                                      {/* <!-- End Dropdown --> */}
                                    </div>
                                    {/* <!-- End Col --> */}
                                  </div>
                                  {/* <!-- End Row --> */}
                                </li>
                                {/* <!-- End List Item --> */}

                                {/* <!-- List Item --> */}
                                <li className="list-group-item">
                                  <div className="row align-items-center">
                                    <div className="col-auto">
                                      <img
                                        className="avatar avatar-xs avatar-4x3"
                                        src="https://htmlstream.com/preview/front-dashboard-v2.1.1/assets/svg/brands/google-slides-icon.svg"
                                        alt="Image Description"
                                      />
                                    </div>
                                    {/* <!-- End Col --> */}

                                    <div className="col">
                                      <h5 className="mb-0">
                                        <a className="text-dark" href="#">
                                          WordPress theme presentation
                                        </a>
                                      </h5>
                                      <ul className="list-inline list-separator small text-body">
                                        <li className="list-inline-item">
                                          Dr.Yassine Jaaidio
                                        </li>
                                        <li className="list-inline-item">
                                          3mb
                                        </li>
                                      </ul>
                                    </div>
                                    {/* <!-- End Col --> */}

                                    <div className="col-auto">
                                      {/* <!-- Dropdown --> */}
                                      <div className="dropdown">
                                        <button
                                          type="button"
                                          className="p-3 card-dropdown-btn rounded-circle"
                                          style={{
                                            background: "none",
                                            border: "none",
                                          }}
                                          id="filesGridDropdown1"
                                          data-bs-toggle="dropdown"
                                          aria-expanded="false"
                                        >
                                          <MoreHoriz />
                                        </button>

                                        <div
                                          className="dropdown-menu dropdown-menu-end"
                                          aria-labelledby="filesListDropdown3"
                                          style={{ minWidth: "13rem" }}
                                        >
                                          <a className="dropdown-item" href="#">
                                            <i className="bi-share dropdown-item-icon"></i>{" "}
                                            <FileOpenOutlined className="dropdown-item-icon" />
                                            Ouvrir
                                          </a>
                                          <a className="dropdown-item" href="#">
                                            <i className="bi-folder-plus dropdown-item-icon"></i>{" "}
                                            <Download className="dropdown-item-icon" />{" "}
                                            Télécharger
                                          </a>
                                        </div>
                                      </div>
                                      {/* <!-- End Dropdown --> */}
                                    </div>
                                    {/* <!-- End Col --> */}
                                  </div>
                                  {/* <!-- End Row --> */}
                                </li>
                                {/* <!-- End List Item --> */}

                                {/* <!-- List Item --> */}
                                <li className="list-group-item">
                                  <div className="row align-items-center">
                                    <div className="col-auto">
                                      <img
                                        className="avatar avatar-xs avatar-4x3"
                                        src="https://htmlstream.com/preview/front-dashboard-v2.1.1/assets/svg/brands/google-docs-icon.svg"
                                        alt="Image Description"
                                      />
                                    </div>
                                    {/* <!-- End Col --> */}

                                    <div className="col">
                                      <h5 className="mb-0">
                                        <a className="text-dark" href="#">
                                          Untitled
                                        </a>
                                      </h5>
                                      <ul className="list-inline list-separator small text-body">
                                        <li className="list-inline-item">
                                          Dr.Yassine Jaaidio
                                        </li>
                                        <li className="list-inline-item">
                                          06-03-2022
                                        </li>
                                      </ul>
                                    </div>
                                    {/* <!-- End Col --> */}

                                    <div className="col-auto">
                                      {/* <!-- Dropdown --> */}
                                      <div className="dropdown">
                                        <button
                                          type="button"
                                          className="p-3 card-dropdown-btn rounded-circle"
                                          style={{
                                            background: "none",
                                            border: "none",
                                          }}
                                          id="filesGridDropdown1"
                                          data-bs-toggle="dropdown"
                                          aria-expanded="false"
                                        >
                                          <MoreHoriz />
                                        </button>

                                        <div
                                          className="dropdown-menu dropdown-menu-end"
                                          aria-labelledby="filesListDropdown4"
                                          style={{ minWidth: "13rem" }}
                                        >
                                          <a className="dropdown-item" href="#">
                                            <i className="bi-share dropdown-item-icon"></i>{" "}
                                            <FileOpenOutlined className="dropdown-item-icon" />
                                            Ouvrir
                                          </a>
                                          <a className="dropdown-item" href="#">
                                            <i className="bi-folder-plus dropdown-item-icon"></i>{" "}
                                            <Download className="dropdown-item-icon" />{" "}
                                            Télécharger
                                          </a>
                                        </div>
                                      </div>
                                      {/* <!-- End Dropdown --> */}
                                    </div>
                                    {/* <!-- End Col --> */}
                                  </div>
                                  {/* <!-- End Row --> */}
                                </li>
                                {/* <!-- End List Item --> */}
                              </ul>
                            </div>
                            <div
                              className={`tab-pane fade ${
                                DocumentactiveTab === "tab3"
                                  ? "show active"
                                  : ""
                              }`}
                              id="v-pills-tab3"
                              role="tabpanel"
                            >
                              <div className="table-responsive border border-bottom">
                                <table className="table text-nowrap table-hover">
                                  <thead>
                                    <tr>
                                      <th scope="col">Fichier</th>
                                      <th scope="col">Par</th>
                                      <th scope="col">Size</th>
                                      <th scope="col">Date </th>
                                      <th scope="col">Action</th>
                                    </tr>{" "}
                                  </thead>
                                  <tbody className="files-list">
                                    <tr>
                                      <th scope="row">
                                        {" "}
                                        <div className="d-flex align-items-center">
                                          {" "}
                                          <div className="me-2">
                                            {" "}
                                            <span className="avatar avatar-xs">
                                              {" "}
                                              <img
                                                src="https://spruko.com/demo/ynex/dist/assets/images/media/file-manager/1.png"
                                                alt=""
                                              />{" "}
                                            </span>{" "}
                                          </div>{" "}
                                          <div>
                                            {" "}
                                            Autre-atterstation - 1.pdf{" "}
                                          </div>{" "}
                                        </div>{" "}
                                      </th>
                                      <td scope="row">Dr.Bennani Yassine</td>
                                      <td>87MB</td>
                                      <td>22,Nov 2022</td>
                                      <td>
                                        <div className="hstack gap-2 fs-15">
                                          <div className="custom-btn fw-bold custom-btn-warning-outline me-2">
                                            <FaEye
                                              style={{ fontSize: "18px" }}
                                            />
                                          </div>
                                          <div className="custom-btn fw-bold custom-btn-warning-outline ">
                                            <Download
                                              style={{ fontSize: "18px" }}
                                            />
                                          </div>
                                        </div>{" "}
                                      </td>
                                    </tr>
                                    <tr>
                                      <th scope="row">
                                        {" "}
                                        <div className="d-flex align-items-center">
                                          {" "}
                                          <div className="me-2">
                                            {" "}
                                            <span className="avatar avatar-xs">
                                              {" "}
                                              <img
                                                src="https://spruko.com/demo/ynex/dist/assets/images/media/file-manager/1.png"
                                                alt=""
                                              />{" "}
                                            </span>{" "}
                                          </div>{" "}
                                          <div>
                                            {" "}
                                            Autre-atterstation - 2.pdf{" "}
                                          </div>{" "}
                                        </div>{" "}
                                      </th>
                                      <td scope="row">Dr.Bennani Yassine</td>
                                      <td>87MB</td>
                                      <td>22,Nov 2022</td>
                                      <td>
                                        <div className="hstack gap-2 fs-15">
                                          <div className="custom-btn fw-bold custom-btn-warning-outline me-2">
                                            <FaEye
                                              style={{ fontSize: "18px" }}
                                            />
                                          </div>
                                          <div className="custom-btn fw-bold custom-btn-warning-outline ">
                                            <Download
                                              style={{ fontSize: "18px" }}
                                            />
                                          </div>
                                        </div>{" "}
                                      </td>
                                    </tr>
                                    <tr>
                                      <th scope="row">
                                        {" "}
                                        <div className="d-flex align-items-center">
                                          {" "}
                                          <div className="me-2">
                                            {" "}
                                            <span className="avatar avatar-xs">
                                              {" "}
                                              <img
                                                src="https://spruko.com/demo/ynex/dist/assets/images/media/file-manager/1.png"
                                                alt=""
                                              />{" "}
                                            </span>{" "}
                                          </div>{" "}
                                          <div>
                                            {" "}
                                            autre-atterstation - 3.pdf{" "}
                                          </div>{" "}
                                        </div>{" "}
                                      </th>
                                      <td scope="row">Dr.Bennani Yassine</td>
                                      <td>87MB</td>
                                      <td>22,Nov 2022</td>
                                      <td>
                                        {" "}
                                        <div className="hstack gap-2 fs-15">
                                          <div className="custom-btn fw-bold custom-btn-warning-outline me-2">
                                            <FaEye
                                              style={{ fontSize: "18px" }}
                                            />
                                          </div>
                                          <div className="custom-btn fw-bold custom-btn-warning-outline ">
                                            <Download
                                              style={{ fontSize: "18px" }}
                                            />
                                          </div>
                                        </div>{" "}
                                      </td>
                                    </tr>
                                    <tr>
                                      <th scope="row">
                                        {" "}
                                        <div className="d-flex align-items-center">
                                          {" "}
                                          <div className="me-2">
                                            {" "}
                                            <span className="avatar avatar-xs">
                                              {" "}
                                              <img
                                                src="https://spruko.com/demo/ynex/dist/assets/images/media/file-manager/1.png"
                                                alt=""
                                              />{" "}
                                            </span>{" "}
                                          </div>{" "}
                                          <div>
                                            {" "}
                                            autre-atterstation - 4.pdf{" "}
                                          </div>{" "}
                                        </div>{" "}
                                      </th>
                                      <td scope="row">Dr.Bennani Yassine</td>
                                      <td>87MB</td>
                                      <td>22,Nov 2022</td>
                                      <td>
                                        {" "}
                                        <div className="hstack gap-2 fs-15">
                                          <div className="custom-btn fw-bold custom-btn-warning-outline me-2">
                                            <FaEye
                                              style={{ fontSize: "18px" }}
                                            />
                                          </div>
                                          <div className="custom-btn fw-bold custom-btn-warning-outline ">
                                            <Download
                                              style={{ fontSize: "18px" }}
                                            />
                                          </div>
                                        </div>{" "}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </>
      ) : (
        <div></div>
      )}
    </div>
  );
};

export default DetailsDeclarations;
